import { connect } from 'react-redux'
import { Accordion } from 'react-accessible-accordion'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import { AccordionItemStyled, OnList } from '../styles'
import ResponseCard from './ResponseCard'
import { PageListUL } from 'modules/mainmenu/pages/styles'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as CategoryClosedIcon } from 'assets/images/icons/category closed.svg'
import { ReactComponent as CategoryOpenedIcon } from 'assets/images/icons/category opend.svg'
import { ReactComponent as PrivateIcon } from 'assets/images/icons/private.svg'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { Link } from 'react-router-dom'
import { checkUser_for_admin_or_owner, checkUser_for_admin_or_owner_or_editor, generateSlug } from 'utils/helpers'
import { MoreButton } from 'modules/app/styles'
import { DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { CustomButton } from 'modules/auth/styles'
import { EmptyListCreateDraft } from 'modules/mainmenu/pages/components/EmptyListCreateDraft'
import { getContents_action, toggleCategoryModal_action, toggleDeleteCategoryModal_action } from 'store/actions'
import { useLocation } from 'react-router-dom'

const CategoryContentPlaceholder = () => (
  <div className='ph-item p-2 m-0' style={{ backgroundColor: 'transparent' }}>
    <div className='ph-col-12 mb-0'>
      <div className='ph-row'>
        <div className='ph-col-6 big' style={{ backgroundColor: '#F0F0FF' }}></div>
        <div className='ph-col-12 small' style={{ backgroundColor: '#F0F0FF' }}></div>
        <div className='ph-col-12 small' style={{ backgroundColor: '#F0F0FF' }}></div>
      </div>
    </div>
  </div>
)

const SortableResponseItemCategorized = SortableElement((props) => {
  const { pathname } = useLocation();

  const getCurrentResponseSlugFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }
  return (
    <OnList className={`child ${props.bordertop ? 'bordertop' : ''} ${!props.isFree && !props.isOnGracePeriod && !props.is_subscribed && !props.value.is_accessible ? 'disabled' : ''} ${generateSlug(props.value) === getCurrentResponseSlugFromUrl() ? 'active' : ''}`}>
      <ResponseCard response={props.value} response_categories={props.response_categories} is_categorized={true} />
    </OnList>
  )
})

const SortableResponseCategoryContainer = SortableContainer((props) => (
  <PageListUL type='response'>
    {props.cat?.contents?.map((r, index) => {
      return (
        <SortableResponseItemCategorized
          collection='sorting-responses'
          key={`item-${index}`}
          index={index}
          value={r}
          cat={props.cat}
          bordertop={props.bordertop}
          response_categories={props.response_categories}
          isOnGracePeriod={props.isOnGracePeriod}
          is_subscribed={props.is_subscribed}
          isFree={props.isFree}
        />
      )
    })}
    {props.loading_category_id === props.cat.uuid && !!!props.cat?.contents?.length && (
      <OnList>
        <div className='response-preview'>
          <CategoryContentPlaceholder />
        </div>
      </OnList>
    )}
  </PageListUL>
))

const SortableResponseCategoryItem = SortableElement((props) => {
  const { AccordionItemHeading, AccordionItemButton, AccordionItemPanel, AccordionItemState } = require('react-accessible-accordion')
  const DragHandle = SortableHandle(() => <span className='dragIcon'>: :</span>)

   const { pathname } = useLocation();

  const getCurrentCategoryFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }

  return (
    <AccordionItemStyled
      level={props.level}
      uuid={`cat_${props.cat.uuid}`}
      className={`accordionItem ${props.childClass || ''} ${props.hoveringSection === `category-${props.cat.id}` ? 'accordionItemHover' : ''}`}>
      <AccordionItemHeading
        className='accordionItemHeading categorySection'
        onMouseEnter={() => props.setIsHoveringSection(`category-${props.cat.id}`)}
        onMouseLeave={() => {
          if (props.parent_cat) {
            props.setIsHoveringSection(`category-${props.parent_cat.id}`)
          } else {
            props.setIsHoveringSection('-')
          }
        }}>
        <AccordionItemButton className='accordionItemButton d-flex justify-content-between'>
          <AccordionItemState>
            {({ expanded }) => (
              <div className='categoryName-wrapper' onClick={() => !expanded && !props.searchText && props.getContents({ type: props.cat.type, category_uuid: props.cat.uuid })}>
                <div className='sortHandleBox'>
                  <DragHandle />
                </div>
                {expanded ? (
                  <div className='expandButton expanded'>
                    <ExpandedOn />
                  </div>
                ) : (
                  <div className='expandButton'>
                    <ExpandedOff />
                  </div>
                )}
                {props.level === 0 && (
                  <Link className={`categoryName ml-1 mr-3 ${getCurrentCategoryFromUrl() === props.cat.uuid ? 'active' : ''}`} to={`/response/category/${props.cat.uuid}`} onClick={(e) => e.stopPropagation()}>
                    {!props.isPrivate && <>{expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />}</>}
                    {props.isPrivate && <PrivateIcon />}
                    <span className='ml-2'> {props.cat.name} </span>
                  </Link>
                )}
                {props.level > 0 && (
                  <div className='categoryName ml-1 mr-3'>
                    <span className='ml-2'> {props.cat.name} </span>
                  </div>
                )}
              </div>
            )}
          </AccordionItemState>

          {checkUser_for_admin_or_owner_or_editor(props.cat, props.user) && (
            <MoreButton className='more-button-dropdown' direction='left' onClick={(e) => e.stopPropagation()}>
              <DropdownToggle caret={false} tag='div'>
                <CustomButton type='button' className='toggle shadow-none'>
                  <MenuIcon />
                </CustomButton>
              </DropdownToggle>
              <DropdownMenu>
                {props.level === 0 && (
                  <DropdownItem
                    className='border-bottom'
                    onClick={() => props.toggleCategoryModal(true, { parent_id: props.cat.id, parent_category: props.cat, root_category: props.cat, type: 'response' })}>
                    Add subcategory
                  </DropdownItem>
                )}
                {checkUser_for_admin_or_owner(props.cat, props.user) && (
                  <>
                    <DropdownItem className='border-bottom' onClick={() => props.toggleCategoryModal(true, { ...props.cat, root_category: null })}>
                      Settings
                    </DropdownItem>
                    <DropdownItem className='border-bottom text-danger' onClick={() => props.toggleDeleteCategoryModal(true, props.cat)}>
                      Delete
                    </DropdownItem>
                  </>
                )}
              </DropdownMenu>
            </MoreButton>
          )}
        </AccordionItemButton>
      </AccordionItemHeading>

      <AccordionItemPanel className={`AccordionItemPanel noline pages ${props.cat.subcategories.length === 0 && props.cat.contents?.length > 0 ? 'pt-0' : ''}`}>
        {props.cat.subcategories.map((sub_cat, index) => (
          <SortableResponseCategoryItem
            collection={`sorting-categories-${props.cat.id}`}
            key={`cat-${sub_cat.id}`}
            index={index}
            level={1}
            cat={sub_cat}
            parent_cat={props.cat}
            isPrivate={props.isPrivate}
            childClass='child'
            onCategorizedResponsesSortEnd={props.onCategorizedResponsesSortEnd}
            setIsHoveringSection={props.setIsHoveringSection}
            hoveringSection={props.hoveringSection}
            response_categories={props.response_categories}
            hideAddDraftLink={props.hideAddDraftLink}
            user={props.user}
            isOnGracePeriod={props.isOnGracePeriod}
            toggleCategoryModal={props.toggleCategoryModal}
            toggleDeleteCategoryModal={props.toggleDeleteCategoryModal}
            is_subscribed={props.is_subscribed}
            isFree={props.isFree}
            getContents={props.getContents}
            loading_category_id={props.loading_category_id}
            searchText={props.searchText}
          />
        ))}

        <div
          onMouseEnter={() => props.setIsHoveringSection(`category-${props.cat.id}`)}
          onMouseLeave={() => {
            if (props.parent_cat) {
              props.setIsHoveringSection(`category-${props.parent_cat.id}`)
            } else {
              props.setIsHoveringSection('-')
            }
          }}>
          <SortableResponseCategoryContainer
            level={0}
            user={props.user}
            isOnGracePeriod={props.isOnGracePeriod}
            helperClass='sorting-item'
            onSortEnd={(indexes) => props.onCategorizedResponsesSortEnd(indexes, props.cat.id)}
            useDragHandle
            cat={props.cat}
            bordertop={props.cat.subcategories.length > 0}
            response_categories={props.response_categories}
            is_subscribed={props.is_subscribed}
            isFree={props.isFree}
            loading_category_id={props.loading_category_id}
          />
          {!props.searchText && props.cat?.contents?.length === 0 && <EmptyListCreateDraft type='response' hideAddDraftLink={props.hideAddDraftLink} level={1} category={props.cat} />}
        </div>
      </AccordionItemPanel>
    </AccordionItemStyled>
  )
})

const SortableResponseCategories = (props) => {
  return (
    <Accordion className='mb-2' allowMultipleExpanded allowZeroExpanded preExpanded={props.preExpanded} key={props.preExpanded.length}>
      {props.response_categories.map((cat, index) => (
        <SortableResponseCategoryItem
          collection='sorting-categories'
          key={`cat-${cat.id}`}
          index={index}
          level={0}
          cat={cat}
          isPrivate={props.isPrivate}
          childClass={props.childClass}
          onCategorizedResponsesSortEnd={props.onCategorizedResponsesSortEnd}
          setIsHoveringSection={props.setIsHoveringSection}
          hoveringSection={props.hoveringSection}
          response_categories={props.response_categories}
          hideAddDraftLink={props.hideAddDraftLink}
          user={props.user}
          isOnGracePeriod={props.isOnGracePeriod}
          toggleCategoryModal={props.toggleCategoryModal}
          toggleDeleteCategoryModal={props.toggleDeleteCategoryModal}
          is_subscribed={props.is_subscribed}
          isFree={props.isFree}
          getContents={props.getContents}
          loading_category_id={props.loading_category_id}
          searchText={props.searchText}
        />
      ))}
    </Accordion>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  isFree: state.company.company.isFree,
  is_subscribed: state.subscription.is_subscribed,
  loading_category_id: state.contents.loading_category_id
})

const mapDispatchToProps = (dispatch) => ({
  getContents: (filters) => new Promise((resolve, reject) => dispatch(getContents_action(filters, resolve, reject))),
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome))
})
export default connect(mapStateToProps, mapDispatchToProps)(SortableResponseCategories)
